module.exports = __webpack_public_path__ + "img/skills.9d4020a1.svg";